<div style="padding-top:20px;">
    <div class="row">
        <div class="col-5">
            <mat-form-field appearance="fill">
                <mat-label>Search</mat-label>
                <input matInput (input)="applySearch($event)" placeholder="Type to Search" name="globalSearch" [value]="previousMapValues['globalSearch'] ?? ''" #input>
            </mat-form-field>
        </div>
        <div class="col-2 text-right pull-right" *ngIf="canPerformAtLeastOneAction()">
            <p class="text-right">
                <button mat-button class="demo-button" [matMenuTriggerFor]="menu">Actions</button>
                <mat-menu #menu="matMenu">
                    <button mat-menu-item *ngIf="showAdd && canPerformAction('add')" (click)="create()">Add</button>
                    <button mat-menu-item *ngIf="selection.selected.length !== 0 && showDelete && canPerformAction('add')"
                        (click)="deleteMany()">Delete</button>
                    <button mat-menu-item *ngIf="canPerformAction('export')" (click)="export()">Export</button>
                    <button mat-menu-item *ngIf="showImport && canPerformAction('import')" (click)="import()">Import</button>
                    <ng-container *ngFor="let action of additionalActions">
                        <span>
                        <button mat-menu-item (click)="handleActionClick(action.key)"
                            *ngIf="canPerformAction(action.key) && (selection.selected.length !== 0 || !action.requireItemSelection)">{{action.name}}</button>
                        </span>
                    </ng-container>
                </mat-menu>
            </p>
        </div>
        <div *ngIf="this.fetchingData" class="text-end" style="display: flex; align-items: center; justify-content: flex-end; flex: 1 1 0; gap: 10px;">
            Fetching data
            <mat-progress-spinner mode="indeterminate" diameter="20" />
        </div>
    </div>

</div>

<div *ngIf="canPerformAtLeastOneAction()" class="text-end">
    {{ selection.selected.length }} selected
</div>

<div class="filter-container" style="padding-top: 20px; overflow-x: auto">
    <div style="min-width: 170px; padding-right: 5px;" *ngFor="let filter of filters">
        <mat-form-field *ngIf="filter.type !== 'dateRange'" appearance="fill">
            <mat-label>{{filter.name}}</mat-label>
            <mat-select multiple [value]="appliedFilters" *ngIf="filter.type === 'select'"  [value]="previousMapValues[filter.key]" panelWidth="null">
                <mat-option *ngFor="let option of filter.options" [value]="option.value" (click)="applyFilter(option.label, filter.key)">{{option.label}}</mat-option>
            </mat-select>
            <input matInput (keyup)="applySearch($event)" *ngIf="filter.type === 'input'" name="{{filter.key}}" [value]="previousMapValues[filter.key] ?? ''"  placeholder="Type to Search" #input>
        </mat-form-field>
        <mat-form-field *ngIf="filter.type === 'dateRange'" appearance="fill">
            <mat-label>{{filter.name}}</mat-label>
            <mat-date-range-input [rangePicker]="picker" >
                <input matStartDate placeholder="Start Date"  [value]="previousMapValues[filter.key]?.start"  #start>
                <input matEndDate placeholder="End Date" #end [value]="previousMapValues[filter.key]?.end"  (dateChange)="dateRangeChange('lastSeen', start, end)">
            </mat-date-range-input>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
    </div>
</div>

<div class="mat-elevation-z8 table-container" *ngIf="filteredDataSource">
    <table mat-table [dataSource]="filteredDataSource" matSort>

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="padding:8px; width: 40px;">
            <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()"
                    color="primary">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)" color="primary">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container *ngFor="let column of displayedColumns">

            <ng-container [matColumnDef]="column.key">
                <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="column.sortable === false" style="padding: 10px;" [style.width]="column.width ?? 'auto'">{{column.label}}</th>
                <td mat-cell *matCellDef="let row" (click)="click(row['id'], column.type!=='menu')">
                    <div *ngIf="column.type==='date'">{{row[column.key] ? (row[column.key] | date:'medium') :
                        '-'}}</div>

                    <div *ngIf="column.type==='string'">{{row[column.key]}}</div>

                    <div *ngIf="column.type==='money'">{{row[column.key] | currency}}</div>

                    <div *ngIf="column.type==='boolean'">
                        <svg *ngIf="row[column.key] > 0" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                            viewBox="0 0 448 512">
                            <!--! Font Awesome Pro 6.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                            <path [attr.fill]="row['color']"
                                d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z" />
                        </svg>
                        <svg *ngIf="row[column.key] === 0" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                            viewBox="0 0 320 512">
                            <path [attr.fill]="row['color']"
                                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
                        </svg>
                    </div>

                    <div *ngIf="column.type==='progress'" style="padding:10px">
                        <mat-progress-bar mode="determinate" [value]="row[column.key]"></mat-progress-bar>
                    </div>

                    <div *ngIf="column.type==='badge'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 512 512">
                            <path [attr.fill]="row['color']"
                                d="M512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256z" />
                        </svg>
                        {{row[column.key]}}
                    </div>

                    <div *ngIf="column.type==='menu'">
                        <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 448 512">
                                <path
                                    d="M120 256C120 286.9 94.93 312 64 312C33.07 312 8 286.9 8 256C8 225.1 33.07 200 64 200C94.93 200 120 225.1 120 256zM280 256C280 286.9 254.9 312 224 312C193.1 312 168 286.9 168 256C168 225.1 193.1 200 224 200C254.9 200 280 225.1 280 256zM328 256C328 225.1 353.1 200 384 200C414.9 200 440 225.1 440 256C440 286.9 414.9 312 384 312C353.1 312 328 286.9 328 256z" />
                            </svg>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="editClick.emit(row['id'])" *ngIf="!clickToEdit">
                                <span>Edit</span>
                            </button>
                            <button mat-menu-item (click)="delete([row['id']])" *ngIf="showDelete">
                                <span>Delete</span>
                            </button>
                        </mat-menu>
                    </div>

                </td>

            </ng-container>

            <mat-progress-bar mode="determinate" value="40"></mat-progress-bar>

        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: columns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <ng-component>
            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4" *ngIf="!this.fetchingData">No results</td>
                <td class="mat-cell" colspan="10" *ngIf="this.fetchingData" >
                    <mat-progress-spinner style="justify-self: center; margin: 10px" mode="indeterminate" diameter="20" />
                </td>
            </tr>
        </ng-component>
    </table>

    <mat-paginator [pageSizeOptions]="[50, 100, 1000]" showFirstLastButtons aria-label="Select page" *ngIf="paginate">
    </mat-paginator>
</div>

<ng-template #bulkActionDialog let-data let-dialogRef="dialogRef">
    <h2 mat-dialog-title>
        {{ data.title }}
    </h2>

    <form [formGroup]="bulkActionConfirmForm" #formDirective="ngForm" (ngSubmit)="onBulkActionConfirm(dialogRef)">
        <mat-dialog-content>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Confirmation number</mat-label>
                <input
                    matInput
                    type="number"
                    formControlName="numItems"
                    required
                />
                <mat-error *ngIf="bulkActionConfirmForm.get('numItems')?.invalid">
                    You must enter {{ selection.selected.length }} to confirm
                </mat-error>
            </mat-form-field>
        </mat-dialog-content>

        <mat-dialog-actions align="end">
            <button mat-button matDialogClose="cancel">Cancel</button>
            <button mat-button type="submit">{{ data.confirmButtonText }}</button>
        </mat-dialog-actions>
    </form>
</ng-template>

<ng-template #deleteDialog>
    <h2 matDialogTitle>Really delete item?</h2>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose="no">No</button>
        <button mat-button matDialogClose="yes">Yes</button>
    </mat-dialog-actions>
</ng-template>
